/**
 * Collapses its children out of the layout, animated, without knowing their
 * height.
 *
 * `grid-template-rows: 1fr → 0fr` with an `overflow: hidden` child is the one
 * technique that transitions to the content's real height in CSS alone. The
 * alternatives are worse: a fixed `max-height` has to be guessed (too small
 * clips, too large makes the easing look broken), and measuring with JS means
 * a layout read on every open.
 *
 * The children also slide *down* as they go, which is the direction that reads
 * as "making room" rather than "being deleted".
 *
 * `aria-hidden` and `inert` follow the visual state, so a collapsed block is
 * not reachable by keyboard or screen reader while it is on its way out.
 */
export default function Collapse({ open, delay = 0, children }) {
  return (
    <div
      aria-hidden={!open}
      inert={open ? undefined : ""}
      style={{ transitionDelay: `${delay}ms` }}
      className={`grid transition-[grid-template-rows,opacity] duration-[700ms] ease-[cubic-bezier(.25,.8,.35,1)] motion-reduce:transition-none ${
        open ? "grid-rows-[1fr] opacity-100" : "pointer-events-none grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        <div
          style={{ transitionDelay: `${delay}ms` }}
          className={`transition-transform duration-[700ms] ease-[cubic-bezier(.25,.8,.35,1)] motion-reduce:transition-none ${
            open ? "translate-y-0" : "translate-y-6"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
